import React, { Component } from 'react';
import { Button, Input, Modal, Form, notification } from 'antd'
import axios from 'axios'
import api from '@root/utils/api'

import '../portal.scss'
const FormItem = Form.Item;

class ChangePwd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            visible: false
        }
    }

    handleOk = () => {
        const form = this.props.form;
        form.validateFields();
        let errors = form.getFieldsError();
        /* 有任何输入不合法就返回 */
        for (let i in errors) {
            if (errors[i]) {
                return;
            }
        }
        const formData = form.getFieldsValue()
        axios.post(api.common.changePwd,{
            'newPassword': formData.password,
            "oldPassword": formData.oldPwd
        }).then(res=>{
            this.props.handleHide()
            notification.success('修改密码成功，请重新登录')
            setTimeout(()=>{
                this.props.history.push('/login')
            },1000)
        }).catch(err=>{
          err.cancelAlert()
          console.log(err)
          notification.error({
            description: err.data.msg,
            duration: 4
          })
        })
    }

    compareToFirstPassword = (e, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue("password")) {
            if(value.length>3) callback("两次输入的密码不一致");
        } else {
            form.resetFields(['password'])
            form.setFields({
                password: {
                    value: value,
                    errors: null
                }
            })
            callback();
        }
    }

    compareToSecondPassword = (e, value, callback) => {
        const form = this.props.form;
        let confirmPassword = form.getFieldValue("confirmPassword")
        if (value && confirmPassword && value !== confirmPassword) {
            if(value.length>3) callback("两次输入的密码不一致");
        } else {
            if (confirmPassword) {
                form.resetFields(['confirmPassword'])
                form.setFields({
                    confirmPassword: {
                        value: value,
                        errors: null
                    }
                })
            }
            callback();
        }
    }

    render() {
        const { visible, handleHide } = this.props
        const { loading } = this.state
        const { getFieldDecorator } = this.props.form

        return (
            <Modal
                visible={visible}
                width={380}
                className="changePwd_Modal"
                onCancel={handleHide}
                // maskClosable={false}
                closable={false}
                centered
                footer={null}
            >
                <Form onSubmit={this.handleOk} hideRequiredMark={true}>
                    <header>修改密码</header>
                    <FormItem
                        label="您的旧密码"
                    >
                        {getFieldDecorator('oldPwd', {
                            rules: [
                                { required: true, message: '请输入旧密码' },
                                // {
                                //     pattern: /^[^\s]{4,20}$/,
                                //     message: "请输入长度为4-20的非空格字符"
                                // }
                            ],
                            validateFirst: true
                        })(
                            <Input maxLength={20} type="password" />
                        )}
                    </FormItem>
                    <FormItem
                        label="设置新密码"
                    >
                        {getFieldDecorator('password', {
                            rules: [
                                { required: true, message: '请输入新密码' },
                                {
                                    pattern: /^[^\s]{4,20}$/,
                                    message: "请输入长度为4-20的非空格字符"
                                },
                                {
                                    validator: this.compareToSecondPassword
                                }
                            ],
                            validateFirst: true
                        })(
                            <Input maxLength={20} placeholder="输入您的新密码" type="password" />
                        )}
                    </FormItem>
                    <FormItem
                        label="确认新密码"
                    >
                        {getFieldDecorator('confirmPassword', {
                            rules: [
                                { required: true, message: '请输入确认新密码' },
                                {
                                    pattern: /^[^\s]{4,20}$/,
                                    message: "请输入长度为4-20的非空格字符"
                                },
                                {
                                    validator: this.compareToFirstPassword
                                }
                            ],
                            validateFirst: true
                        })(
                            <Input maxLength={20} placeholder="再次输入新密码以确认" type="password" />
                        )}
                    </FormItem>
                    <Button key="submit" className="changePwd_btn" type="primary" loading={loading} onClick={this.handleOk}>
                        确认修改
                    </Button>
                    <p className="forget_text">忘记密码？联系管理员找回<a href="mailto:dotransit@udiannet.com">dotransit@udiannet.com</a></p>
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(ChangePwd)



// WEBPACK FOOTER //
// ./src/view/Portal/Modal/changePwd.js